import React from 'react';
import { motion } from 'framer-motion';
import { Terminal, ShieldAlert, BadgeCheck } from 'lucide-react';
import Section from '../components/Section';

const skills = [
  {
    label: 'Languages',
    Icon: Terminal,
    accent: '#00ff88',
    items: ['Python', 'JavaScript', 'Go'],
  },
  {
    label: 'Security',
    Icon: ShieldAlert,
    accent: '#f43f5e',
    items: ['OWASP Top 10', 'VAPT', 'Incident Response', 'Digital Forensics'],
  },
  {
    label: 'Certifications',
    Icon: BadgeCheck,
    accent: '#f59e0b',
    items: ['CEH v13', 'TryHackMe Advent of Cyber', 'Google Cloud Badges', 'NPTEL DSA'],
  },
];

export default function Skills() {
  return (
    <Section id="skills" title="Skills">
      <div className="skills-v2-grid">
        {skills.map((s, i) => (
          <motion.div
            key={s.label}
            className="skills-v2-card"
            style={{ '--accent': s.accent }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.1 }}
          >
            <div className="skills-v2-header">
              <s.Icon size={16} color={s.accent} strokeWidth={2} />
              <span className="skills-v2-label">{s.label}</span>
            </div>
            <div className="skills-v2-chips">
              {s.items.map((item) => (
                <span key={item} className="skills-v2-chip">{item}</span>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
